/* eslint-disable
    @typescript-eslint/no-unused-vars,
    eqeqeq,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const $ = require('jquery');
const Alerts = require('app/scripts/views/lib/alerts');
const templates = require('app/scripts/views/internal/templates');
const { track } = require('@trello/analytics');

let reportedError = false;

module.exports = function (err, { isUsingSocket, dateLastMessage }) {
  Alerts.showHtml(
    templates.fill(require('app/scripts/views/templates/sync_error')),
    'error',
    'modelSync',
  );
  if (!reportedError) {
    reportedError = true;

    // We get back an error message that will contain something like
    // "ixSinceUpdate too high: 2 > 1 (...id...)"
    // "ixSinceUpdate too low. 1 < 2 (...id...)"
    const parts =
      /too (low|high)[\.:]\s+(\d+)\s[<>]\s(\d+)/.exec(err.message) || [];
    const [all, lowOrHigh, value1, value2] = Array.from(parts);

    track(
      'Error',
      'Sync Error',
      isUsingSocket ? 'Using Socket' : 'Using AJAX',
      parts != null
        ? lowOrHigh === 'high'
          ? 'Too High'
          : 'Too Low'
        : 'Unknown',
      // The difference between the two values that came back in the error message,
      // so we have a sense of how far past the queue length we were
      parts != null
        ? Math.abs(parseInt(value1, 10) - parseInt(value2, 10))
        : undefined,
    );

    const timeSinceGoodConnection = Date.now() - (dateLastMessage || 0);

    $.ajax({
      url: '/test-connection',
      timeout: 3000,
    })
      .fail(() => {
        return track(
          'Error',
          'Sync Error Connectability',
          'Unreachable',
          undefined,
          timeSinceGoodConnection,
        );
      })
      .done(() => {
        return track(
          'Error',
          'Sync Error Connectability',
          'Reachable',
          undefined,
          timeSinceGoodConnection,
        );
      });
  }
};
